import React from 'react';

const LeadGenerationContext = React.createContext();

export const LeadGenerationProvider = LeadGenerationContext.Provider;

export default LeadGenerationContext;
